var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("validation-provider", {
    attrs: { rules: _vm.validates, name: _vm.name },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ errors }) {
          return [
            _c(
              "div",
              {
                staticClass: "phone-input-wrap form-group",
                class: { "has-errors": errors.length },
                style: { marginBottom: _vm.marginBottom },
              },
              [
                _vm.label
                  ? _c("label", { staticClass: "form-control-label" }, [
                      _vm._v(_vm._s(_vm.label)),
                    ])
                  : _vm._e(),
                _c("vue-tel-input", {
                  attrs: {
                    "input-options": {
                      name: _vm.name,
                      placeholder: _vm.placeholder,
                      autocomplete: "off",
                      styleClasses: {
                        "form-control": true,
                        "is-invalid": errors.length,
                      },
                      autofocus: false,
                      showDialCode: false,
                      tabindex: 0,
                    },
                    disabled: _vm.disabled,
                    "valid-characters-only": true,
                    "ignored-countries": ["IO", "NR", "SH", "SX", "TK", "WF"],
                    mode: _vm.mode,
                  },
                  on: { validate: _vm.handleValidate, input: _vm.handleInput },
                  model: {
                    value: _vm.phoneNumber,
                    callback: function ($$v) {
                      _vm.phoneNumber = $$v
                    },
                    expression: "phoneNumber",
                  },
                }),
                errors.length
                  ? _c("b-form-invalid-feedback", [_vm._v(_vm._s(errors[0]))])
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }